import { defineSettingsScreen } from '@heidi/runtime/shell';

/**
 * Declares the Integration Agent settings screen through the shell.
 */
export const integrationAgentSettingsScreen = defineSettingsScreen({
  id: 'integration-agent',
  section: 'integrations',
  order: 1,
  load: () =>
    import('../connected-apps/ui/integration-agent/integration-agent-settings').then(
      (module) => ({ default: module.IntegrationAgentSettings })
    ),
  builds: 'all',
});
